module.exports = __webpack_public_path__ + "static/img/menu1-img3.6652526b.png";